import { formatMoney } from '@shopify/theme-currency';
import { getTranslation } from '../../helpers';
import { h } from 'preact';
import { useCartContext } from '../context/CartContext';

const CartTotals = () => {
  const {
    cart: { cart_level_discount_applications, total_price },
  } = useCartContext();

  return (
    <div>
      <div class="type-heading-4 flex items-center justify-between">
        <p>{getTranslation('cart.subtotal')}</p>
        <p>{formatMoney(total_price, theme.moneyFormat)}</p>
      </div>

      {/* <div class="type-body-large mt-2 flex items-center justify-between">
        <p>{getTranslation('mini_cart.shipping')}</p>
        <p class="type-body-small">
          {getTranslation('mini_cart.shipping_at_checkout')}
        </p>
      </div> */}

      {/* Discounts */}
      {cart_level_discount_applications.length > 0 && (
        <div class="mt-4 flex flex-col items-end space-y-2">
          {cart_level_discount_applications.map(item => (
            <div class="type-body-small">
              {item.title} (-
              {formatMoney(item.total_allocated_amount, theme.moneyFormat)})
            </div>
          ))}
        </div>
      )}
    </div>
  );
};

export default CartTotals;
